import Vue from 'vue';
import Router from 'vue-router';
import middleware from './middleware';
import routes from '@/routes';
Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  middleware(to, next, router);
});

export default router;
